module.exports = __webpack_public_path__ + "static/media/40291b45.jpg";